<div class="container-fluid" style=" padding-right: 0px; padding-left: 0px">
  <app-nav-menu></app-nav-menu>
</div>
<div class="container" id="desktop">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.6em; font-weight:bold">
      FAQs
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      What Is A Class Action Lawsuit?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        A class action is a lawsuit in which one or more representative plaintiffs (in this case, Plaintiffs) bring a lawsuit on behalf of themselves and other similarly
        situated persons (<i>i.e.</i>, a class) who have similar claims against the defendants. The representative plaintiffs, the court, and counsel appointed to represent
        the class all have a responsibility to make sure that the interests of all class members are adequately represented.
      </p>
      <p>
        Importantly, class members are NOT individually responsible for payment of attorneys&rsquo; fees or litigation expenses. In a class action, attorneys&rsquo; fees and
        litigation expenses are paid directly by the defendants, from the court-awarded judgment amount, or, as in this case, from the settlement fund, and such payment must
        be approved by the court. If there is no recovery on behalf of the class, the attorneys do not get paid.
      </p>
      <p>
        When a representative plaintiff enters into a settlement with a defendant on behalf of a class, such as in this Settlement with GoodRx and Criteo, the court will
        require that the members of the class be given notice of the settlement and an opportunity to be heard with respect to the settlement. The court then conducts a
        hearing (called a Final Approval Hearing) to determine, among other things, if the settlement is fair, reasonable, and adequate.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      Why Was There A Notice?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        Potential Settlement Class Members have a right to know about the proposed Settlement with GoodRx and Criteo before the Court decides whether to approve the
        Settlement.
      </p>
      <p>
        This <a href="../../../assets/docs/GoodRx Criteo - Long Form Notice V2.pdf" target="_blank" style="color:#006cDb">Notice</a> explains the cases in
        the consolidated litigation,<sup>1</sup> <i>Doe v. GoodRx Holdings, Inc. et al</i>, No. 3:23-cv-00501-AMO, pending in the U.S.
        District Court for the Northern District of California (the &ldquo;Litigation&rdquo;), the Settlement, your legal rights, what benefits are available, who is
        eligible for them, and how you can apply to receive your portion of the benefits if you are eligible. The purpose of this Notice is also to inform you of the Final
        Approval Hearing to be held by the Court to consider the fairness, reasonableness, and adequacy of the
        <a href="../../../assets/docs/Settlement Agreement.pdf" target="_blank" style="color:#006cDb">Settlement</a>, and to consider requests for awards of
        attorneys&rsquo; fees and litigation expenses, and any service awards for Plaintiffs.
      </p>
      <p style="font-size:.8em">
        <sup>1</sup> This Action was consolidated with <i>Doe v. GoodRx Holdings, Inc. et al</i>, No. 3:23-cv-00744-VC (N.D. Cal.), <i>Marquez v. GoodRx Holdings, Inc. et
        al</i>, No. 3:23-cv-00940-VC (N.D. Cal.), <i>Wilson v. GoodRx Holdings, Inc. et al</i>, No. 3:23-cv-01293-VC (N.D. Cal.), and <i>E.C. v. GoodRx Holdings, Inc. et
        al</i>, No. 3:23-cv-01508-VC (N.D. Cal.) on May 3, 2023. See ECF No. 85.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      What Are The Definitions Used In This Notice?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        This Notice incorporates by reference the definitions in the Amended Class Action Settlement Agreement and Release with GoodRx and Criteo (the &ldquo;Settlement
        Agreement&rdquo;).
      </p>
      <p>
        The Settlement Agreement and the Court&rsquo;s Preliminary Approval Order are posted on the Settlement Website. All capitalized terms used in this Notice, but not
        otherwise defined, shall have the same meanings as in the Settlement Agreement and the Court&rsquo;s Preliminary Approval Order.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      What Is This Litigation About?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        GoodRx is a combination telehealth and prescription coupon company that provides millions of people with telehealth services, coupons for prescription medication,
        and other health-related services each month. When people use GoodRx&rsquo;s services, GoodRx collects their personal and health information, including information
        about their prescription medications and health conditions, email addresses, and phone numbers. Plaintiffs allege that between at least 2017 and 2020, GoodRx
        disclosed this sensitive personal health information to advertising and analytics companies, including Criteo and Remaining Defendants, through GoodRx&rsquo;s
        incorporation of Criteo and Remaining Defendants&rsquo; technologies on the GoodRx platform. Plaintiffs also allege that Criteo and Remaining Defendants used this
        information for their own purposes.
      </p>
      <p>
        Plaintiffs brought this Litigation against GoodRx, Criteo, and Remaining Defendants on behalf of themselves and the Class alleging that this conduct violated Class
        Members&rsquo; privacy rights along with various state privacy and consumer protections laws. Plaintiffs assert claims against GoodRx, Criteo, and Remaining
        Defendants for intrusion upon seclusion, unjust enrichment, violation of the California Confidentiality of Medical Information Act (&ldquo;CMIA&rdquo;), violation
        of the California Invasion of Privacy Act (&ldquo;CIPA&rdquo;), violation of the California Consumers Legal Remedies Act (&ldquo;CLRA&rdquo;), violation of
        California&rsquo;s Unfair Competition Law (&ldquo;UCL&rdquo;), violation of New York&rsquo;s General Business Law (&ldquo;GBL&rdquo;), violation of the Illinois
        Consumer Fraud and Deceptive Business Practices Act, negligence, and negligence per se and seek compensation for GoodRx users whose information was disclosed to
        Criteo and Remaining Defendants without their consent.
      </p>
      <p>
        GoodRx and Criteo dispute Plaintiffs&rsquo; allegations and deny that they violated any law. GoodRx and Criteo further maintain that they have valid and meritorious
        defenses as to some or all of the claims asserted in this Litigation. Nevertheless, to avoid the expense and uncertainty of further litigation, GoodRx and Criteo
        have agreed to settle the claims asserted against them in this Litigation, and to pay a total of thirty-two million U.S. Dollars ($32,000,000) for the benefit of
        the Settlement Class to resolve the Settlement Class&rsquo;s claims against them. This Settlement does not include the claims Plaintiffs maintain against the
        Remaining Defendants, which they continue to pursue. If the Settlement is approved, each Authorized Claimant will receive a share of the Settlement Amount plus any
        interest that may accrue, less any Court-approved disbursements, including: (i) reasonable Notice and Settlement Administration Costs; (ii) any taxes owed by the
        Settlement Fund; (iii) any Settlement Fund account costs to hold and invest the Settlement fund; (iv) any Attorneys&rsquo; Fees and Expenses Award; (v) service
        awards to Class Representatives; and (vi) any other costs or awards approved by the Court (the &ldquo;Net Settlement Fund&rdquo;). The share of the Net Settlement
        Fund received by each Authorized Claimant (the &ldquo;Claim Payment&rdquo;) will depend on the total number of eligible claims that receive approval to
        participate in the Settlement. If the Settlement is not approved, the Litigation will continue against GoodRx and Criteo, and Plaintiffs will continue to pursue
        their claims against GoodRx and Criteo along with their claims against Remaining Defendants.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      What Is The History Of This Litigation?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        On February 1, 2023, the Federal Trade Commission (&ldquo;FTC&rdquo;) filed an action against GoodRx alleging it violated the FTC Act and the FTC&rsquo;s Health
        Breach Notification Rule by disclosing its users&rsquo; personally identifiable information and details about their medications and sensitive health conditions to
        third parties, including Criteo and Remaining Defendants.
      </p>
      <p>
        Beginning on February 2, 2023, putative class action complaints were filed against GoodRx as a result of the alleged disclosure of personal and health information
        of its users. Those actions were consolidated with this Litigation on May 3, 2023 and a Consolidated Class Action Complaint was filed on May 26, 2023. On July 7,
        2023, Lowey Dannenberg, P.C., and Bursor &amp; Fisher, P.A. were appointed interim co-lead class counsel (&ldquo;Class Counsel&rdquo;) and given the authority to
        conduct settlement discussions in this Litigation, and any subsequently related actions, on behalf of Plaintiffs and proposed Class Members. GoodRx moved to compel
        arbitration and dismiss the Litigation. Plaintiffs opposed GoodRx&rsquo;s motions. Ultimately, these motions were dismissed without prejudice pending the outcome of
        a forthcoming mediation.
      </p>
      <p>
        On January 10, 2024, Plaintiffs and GoodRx engaged in the first mediation conference before the Honorable Ellen Sickles James. Plaintiffs and GoodRx then engaged in
        a second mediation on March 7, 2024 before the Honorable Wayne Andersen (ret.) that lasted a full day. Plaintiffs and GoodRx made significant progress and following
        multiple telephonic conferences, reached a settlement.
      </p>
      <p>
        In 2025, Plaintiffs and Criteo reengaged in settlement negotiations. Plaintiffs and Criteo also reached an agreement in their negotiations. Then settlement terms
        with GoodRx and Criteo were further refined and combined. On November 19, 2025, Plaintiffs, GoodRx, and Criteo reached an amended settlement, reflected in the
        Settlement Agreement.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      Why Is There A Settlement?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        Plaintiffs and Class Counsel believe that Settlement Class Members have been damaged by GoodRx and Criteo&rsquo;s conduct. GoodRx and Criteo do not admit the
        allegations made by Plaintiffs, believe that they have meritorious defenses to Plaintiffs&rsquo; allegations, and believe that Plaintiffs&rsquo; claims would have
        been rejected prior to trial, at trial (had Plaintiffs successfully certified a class and survived summary judgment motions), or on appeal. As a result, GoodRx and
        Criteo believe Plaintiffs would have received nothing if the Litigation had continued to trial.
      </p>
      <p>
        The Court has not decided in favor of either Plaintiffs or GoodRx and Criteo. Instead, Class Counsel engaged in negotiations with GoodRx and Criteo to reach a
        negotiated resolution of the Litigation. The
        <a href="../../../assets/docs/Settlement Agreement.pdf" target="_blank" style="color:#006cDb">Settlement</a> allows both sides to avoid the risks and costs of
        lengthy litigation and the uncertainty of pre-trial
        proceedings, a trial, and appeals, and, if approved, will permit Settlement Class Members who file timely and valid Claim Forms to receive some compensation,
        rather than risk ultimately receiving nothing. Plaintiffs and Class Counsel believe the Settlement is in the best interest of all Settlement Class Members.
      </p>
      <p>
        GoodRx and Criteo have agreed to pay a total of thirty-two million U.S. Dollars ($32,000,000) in cash for the benefit of the proposed Settlement Class. If the
        Settlement is approved, each Settlement Class Member who submits a timely and valid Settlement Claim Form may be eligible to receive a Claim Payment from the Net
        Settlement Fund.
      </p>
      <p>
        If the Settlement is approved, the Litigation and related class actions will be resolved against GoodRx and Criteo, and all Released Claims against the Released
        Parties will be released by the Releasing Parties. If the Settlement is not approved, GoodRx and Criteo will remain as defendants in the Litigation, and Plaintiffs
        will continue to pursue their claims against GoodRx, Criteo, and Remaining Defendants.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      How Do I Know If I Am A Settlement Class Member?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        In the
        <a href="../../../assets/docs/0379. (09-08-2026) ORDER PRELIMINARILY APPROVING THE PROPOSED CLASS ACTION SETTLEMENT, SCHEDULING HEARING FOR FINAL APP.pdf"
           target="_blank" style="color:#006cDb">Preliminary Approval Order</a>, the Court preliminarily approved the following Settlement Class:
      </p>
      <p>
        <i>All natural persons in the United States who used any website, app, or service made available by or through GoodRx at any time prior to April 20, 2024.</i>
      </p>
      <p>
        The Preliminary Approval Order was issued by the Court on <b>September 8, 2026</b>. Not everyone who fits the description will be a Settlement Class Member. Please
        see the question below, &ldquo;Are There Exceptions To Being Included In The Settlement Class?,&rdquo; for a discussion of exclusions from the Settlement Class.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      Are There Exceptions To Being Included In The Settlement Class?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        Yes. Excluded from the Settlement Class are: (a) Defendants and their affiliates, parents, subsidiaries, officers, and directors; (b) the Opt-Outs; (c) Meta and
        Google; as well as (d) the judges presiding over this matter and the clerks of said judges. Anyone who excludes themselves is also not included in the Settlement
        Class (see the question below, &ldquo;How Do I Exclude Myself?&rdquo;).
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      What If I Am Still Not Sure If I Am Included In The Settlement Class?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        If you are still not sure whether you are included in the Settlement Class, you can ask for free help. You can email
        <a href="mailto:info@goodrxprivacysettlement.com" style="color:#006cDb">info@goodrxprivacysettlement.com</a>, call toll-free
        <a href="tel:+18778889232" style="color:#006cDb">1-877-888-9232</a>, or visit the
        Settlement Website, <a href="https://www.goodrxprivacysettlement.com/" target="_blank" style="color:#006cDb">www.goodrxprivacysettlement.com</a>, for more information.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      What Does The Settlement Provide?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        GoodRx and Criteo have agreed to pay a sum of thirty-two million U.S. Dollars ($32,000,000) for the benefit of the proposed Settlement Class. If the Settlement is
        approved, each Settlement Class Member who submits a timely and valid Claim Form will receive an equal share of the Net Settlement Fund after any Court-approved
        disbursements, including (i) Notice and Settlement Administration Costs; (ii) Taxes; (iii) Settlement Fund account costs; and (iv) attorneys&rsquo; fees and expenses,
        (v) service awards, and (vi) any other costs or awards approved by the Court, are paid.
      </p>
      <p>
        The Settlement gives GoodRx and Criteo the right, but not the obligation, in their sole discretion to terminate the Settlement in the event that the number of
        Settlement Class Members who timely exercise their right to request exclusion from the Settlement Class exceeds an agreed upon number.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      How Will I Get A Payment?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        If you are a Settlement Class Member and do not exclude yourself, you are eligible to submit a
        <a href="https://goodrxprivacysettlement.com/file-not-noticed" target="_blank" style="color:#006cDb">Claim Form</a> to receive your share of money from the Net
        Settlement Fund. Claim Forms must be submitted online at the Settlement Website on or before 11:59 p.m. Eastern Time on <b>December 29, 2026</b> OR mailed to the below
        address postmarked no later than <b>December 29, 2026</b>:
      </p>
      <p style="text-align:center">
        GoodRx Data Disclosure Settlement<br>
        c/o A.B. Data, Ltd.<br>
        P.O. Box 173138<br>
        Milwaukee, WI 53217
      </p>
      <p>
        Following the timely submission and receipt of your Claim Form online, a printable &ldquo;Confirmation of Claim Receipt&rdquo; will be displayed on the screen,
        which will acknowledge receipt of your Claim. If you do not submit a Claim Form, you will not receive any payment under the Settlement.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      How Much Will My Payment Be?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        At this time, it is not known precisely how much each Authorized Claimant will receive as the Settlement Payment or when payments will be made. The amount of the
        Settlement Payment will depend on the number of claims that receive approval.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      When Will I Receive A Payment?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        The Court will hold the Final Approval Hearing on <b>February 11, 2027</b> to decide whether to approve the Settlement. If the Court approves the Settlement, there
        may be appeals after that. It can sometimes take a year or more for the appellate process to conclude.
      </p>
      <p>
        Do not contact the Court or Court clerk for updates.
      </p>
      <p>
        Please be patient; status updates will be posted on the Settlement Website.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      What Do I Have To Do After I File A Claim Form?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        After you file a <a href="https://goodrxprivacysettlement.com/file-not-noticed" target="_blank" style="color:#006cDb">Claim Form</a>, the Settlement Administrator
        will evaluate your Claim Form to determine if you have provided sufficient information to validate your
        membership in the Settlement Class and to approve the claim submitted. If the Settlement Administrator determines that your Claim Form is deficient or defective,
        it will contact you, and you will have twenty (20) days from the date of the written notice to cure the deficiencies. If you subsequently provide information that
        satisfies the Settlement Administrator concerning the validity of your Claim Form, you will not have to do anything else. If the defect is not cured within the
        20-day period, then the Claim will be deemed invalid. If any disputes cannot be resolved, Class Counsel will submit them to the Court, and the Court will make a
        final determination of the validity of your Claim Form.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      What Am I Giving Up To Receive A Payment?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        Unless you exclude yourself, you remain a Settlement Class Member. That means you cannot sue, continue to sue, or be part of any other lawsuit about the Released
        Claims in this Litigation or any other action against GoodRx and Criteo. Upon the Effective Date of the Settlement, Plaintiffs and the Releasing Parties shall
        release and be deemed to release and forever discharge and shall be forever enjoined from prosecuting the Released Claims against the Released Parties.
      </p>
      <p>
        The capitalized terms used in this paragraph are defined in the Settlement Agreement, Preliminary Approval Order, or this Notice. For easy reference, certain of
        these terms are copied below:
      </p>
      <p>
        &ldquo;Releasing Parties&rdquo; means Plaintiffs and the Settlement Class Members who do not timely and validly opt out from the Settlement pursuant to Fed. R.
        Civ. P. 23(c) and in accordance with the procedure to be established by the Court, and each of their past, present, and future heirs, estates, trustees,
        principals, beneficiaries, guardians, executors, administrators, representatives, agents, attorneys, partners, successors, predecessors in-interest, and assigns
        and/or anyone claiming through them or acting or purporting to act for them or on their behalf.
      </p>
      <p>
        &ldquo;Released Parties&rdquo; means jointly and severally, individually and collectively, Defendants GoodRx and Criteo, their predecessors; successors; assigns;
        insurers; and any and all past, present, and future parents, owners, subsidiaries, divisions, departments, and affiliates, and all of their past, present, and
        future heirs, executors, devisees, administrators, officers, executives, directors, stockholders, partners, members, agents, attorneys, advisors, auditors,
        accountants, contractors, servants, employees, representatives, insurers, and assignees.
      </p>
      <p>
        &ldquo;Released Claims&rdquo; means any and all manner of claims, counterclaims, lawsuits, set-offs, costs, expenses, attorneys&rsquo; fees and costs, losses,
        rights, demands, charges, complaints, actions, suits, causes of action, obligations, debts, contracts, penalties, damages, or liabilities of any nature whatsoever,
        known, unknown, or capable of being known, in law or equity, fixed or contingent, accrued or unaccrued, and matured or not matured that arise out of, or are based
        upon or connected to, or relate in any way to the Data Disclosure or GoodRx and Criteo&rsquo; use of Pixels, SDKs, cookies, APIs, or any similar technologies, or
        that were or could have been asserted in the litigation. Released Claims include the release of unknown claims. Released Claims do not include the right of any of
        the Releasing Parties or any of the Released Parties to enforce the terms of the Settlement contained in the Settlement Agreement.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      What If I Do Nothing?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        You are automatically a member of a Settlement Class if you fit the Settlement Class description. However, if you do not submit a timely and valid Claim Form, you
        will not receive any payment from the Settlement. You will be bound by past and any future Court rulings, including rulings on the Settlement and release. Unless
        you exclude yourself, you will not be able to start a lawsuit, continue with a lawsuit, or be a part of any other lawsuit against GoodRx or Criteo on the basis of
        the Released Claims. Please see the question above, &ldquo;What Am I Giving Up To Receive A Payment?,&rdquo; for a description of the Released Claims.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      What If I Do Not Want To Be In The Settlement Class?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        If you are a Settlement Class Member, do not want to remain in the Settlement Class, and do not want a payment from the Settlement, then you must take steps to
        exclude yourself from the Settlement. This is also sometimes referred to as &ldquo;opting out&rdquo; of a class. See the question below, &ldquo;How Do I Exclude
        Myself?&rdquo;
      </p>
      <p>
        If you validly exclude yourself from the Settlement Class of which you would otherwise be a member, you may file a lawsuit against GoodRx or Criteo on your own for
        the claims being resolved by the Settlement. However, you will not receive any money from the Settlement, and Class Counsel will no longer represent you with
        respect to any claims against GoodRx and Criteo.
      </p>
      <p>
        If you want to receive money from the Settlement, do not exclude yourself. You must file a Claim Form to receive any payment from the Settlement.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      How Do I Exclude Myself?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        You can exclude yourself by sending a written &ldquo;Request for Exclusion.&rdquo; You cannot exclude yourself by telephone. Your written Request for Exclusion must be
        sent to the Settlement Administrator postmarked no later than <b>December 29, 2026</b> and sent by U.S. Mail or other delivery service to:
      </p>
      <p style="text-align:center">
        GoodRx Data Disclosure Settlement<br>
        Attn: Exclusions<br>
        P.O. Box 173001<br>
        Milwaukee, WI 53217
      </p>
      <p>
        The written Request for Exclusion must (i) identify the case name and number of the Litigation (<i>Doe v. GoodRx Holdings, Inc., et al.</i>, Case No 4:23-cv-00501-AMO
        (N.D. Cal.)); (ii) identify your full name, current address, telephone number, and email address; (iii) include the claimant ID code and other information included
        on the Summary Notice of Proposed Class Action Settlement (&ldquo;Short Form Notice&rdquo;) provided by the Settlement Administrator that identifies you as a
        Settlement Class Member; (iv) include your original signature, and, if represented by counsel, be signed by your counsel; and (v) include a statement clearly
        indicating your intent to be excluded from the Settlement.
      </p>
      <p>
        A Request for Exclusion that does not include all of the foregoing information, that does not contain the proper signature, that is sent to an address other than
        the one designated above, or that is not sent within the time specified shall be invalid and the person(s) filing such an invalid request shall be a Settlement
        Class Member and shall be bound by the Settlement, if approved.
      </p>
      <p>
        All persons who submit valid and timely Requests for Exclusion in the manner set forth above shall have no rights under the Settlement, shall not share in the
        distribution of the Net Settlement Fund, and shall not be bound by the Settlement. In addition, such persons will not be entitled to object to the Settlement or
        appear at the Final Approval Hearing.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      If I Do Not Exclude Myself, Can I Sue GoodRx Or Criteo For The Same Thing Later?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        No. Unless you exclude yourself from this Settlement, you give up any right to sue GoodRx and Criteo for the Released Claims that the Settlement resolves.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      If I Exclude Myself, Can I Get Money From The Settlement?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        No. You will not get any money from the Settlement if you exclude yourself.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      If I Exclude Myself, Can I Still Object?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        No. If you exclude yourself, you are no longer a Settlement Class Member and may not object to any aspect of the Settlement.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      How Do I Tell The Court What I Think About The Settlement?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        If you are a Settlement Class Member and you do not exclude yourself, you can tell the Court what you think about the Settlement. You can object to all or any part
        of the Settlement, the application for attorneys&rsquo; fees and expenses, and/or service awards for Plaintiffs. You can give reasons why you think the Court should
        approve them or not. You cannot ask the Court to order a different settlement; the Court can only approve or reject the Settlement. If the Court denies approval, no
        settlement payments will be sent out, and the lawsuit will continue. If that is what you want to happen, you should object. The Court will consider your views. If
        you want to make an objection, you may enter an appearance in the Litigation, at your own expense, individually or through counsel of your own choice, by
        electronically filing or mailing a notice of appearance and your objection to the Clerk of Court, United States District Court for the Northern District of
        California, 1301 Clay Street, Suite 400 S Oakland, CA 94612 by <b>December 29, 2026</b>.
      </p>
      <p>
        Any Settlement Class Member who does not enter an appearance will be represented by Class Counsel. If you choose to object, you must file a written objection. You
        cannot make an objection by telephone or email. Your written objection must include: (i) the case name and number of the Litigation (<i>Doe v. GoodRx Holdings,
        Inc., et al.</i>, Case No 4:23-cv-00501-AMO (N.D. Cal.)); (ii) your full name, current address, telephone number, and email address; (iii) your original signature;
        (iv) proof or an attestation that you are a member of the Settlement Class, which proof may include the claimant ID code and other information included on the
        Short Form Notice provided by the Settlement Administrator that identifies you as a Settlement Class Member; (v) a statement of whether the objection applies only
        to you, to a specific subset of the Settlement Class, or to the entire Settlement Class; (vi) a statement of the legal and factual basis for the objection; (vii)
        copies of any documents that you wish to submit in support of your position; (viii) identification of all counsel representing you, if any; (ix) the signature of
        your duly authorized attorney or other duly authorized representative, if any. Note that all documents sent to the Court by any Settlement Class member, including
        any letter or document expressing the Settlement Class Member&rsquo;s desire to be excluded from the Class and any objection to the proposed Settlement, voluntary
        dismissal, or compromise, are filed electronically by the clerk and therefore will be available for public review. Objections should thus not include medical
        documentation or sensitive private information.
      </p>
      <p>
        If you file a timely written objection, you may, but are not required to, appear at the Final Approval Hearing. If you intend to speak at the Final Approval
        Hearing (whether <i>pro se</i> or through an attorney), you must file a notice of appearance and your written objection must identify: (a) the attorney(s)
        representing you who will appear at the Final Approval Hearing by including counsel&rsquo;s name, address, phone number, and email address; (b) any witnesses
        (including yourself, if applicable) that you or they may seek to call to testify at the Final Approval Hearing; and (c) all exhibits you may introduce into
        evidence at the Final Approval Hearing.
      </p>
      <p>
        If you do not timely and validly submit your objection, your views will not be considered by the Court or any court on appeal. Check the Settlement Website,
        <a href="https://www.goodrxprivacysettlement.com/" target="_blank" style="color:#006cDb">www.goodrxprivacysettlement.com</a>, for updates on important dates and
        deadlines relating to the Settlement.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      What Is The Difference Between Objecting And Excluding Myself?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        Objecting is telling the Court that you do not like something about the Settlement. You can object to the Settlement only if you remain a Settlement Class Member
        and do not exclude yourself from the Settlement. Excluding yourself from the Settlement is telling the Court that you do not want to be a part of the Settlement
        Class. If you exclude yourself, you have no right to object to the Settlement because it no longer affects you.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      Do I Have A Lawyer In This Case?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        The Court has appointed the lawyers listed below to represent you and the Settlement Class in this Litigation:
      </p>
      <div class="table-responsive">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td style="font-weight:bold; vertical-align:middle; width:25%">
                <img class="brand__logo" src="../../../assets/images/LogoLowey.png" alt="">
              </td>
              <td style="vertical-align:middle; width:75%">
                <b>Christian Levis</b><br />
                LOWEY DANNENBERG, P.C.<br />
                44 South Broadway<br />
                Suite 1100<br />
                White Plains, NY 10601<br />
              </td>
            </tr>
            <tr>
              <td style="font-weight:bold; vertical-align:middle; width:25%">
                <img class="brand__logo" src="../../../assets/images/BFishlogo.png" alt="">
              </td>
              <td style="vertical-align:middle; width:75%">
                <b>L. Timothy Fisher</b><br />
                BURSOR &amp; FISHER, P.A.<br />
                1990 North California Blvd., 9th Floor<br />
                Walnut Creek, CA 94596<br />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        These lawyers are called Class Counsel. Class Counsel may apply to the Court for payment of attorneys&rsquo; fees and Litigation Expenses that will be paid from
        the Settlement Fund. You will not otherwise be charged for Class Counsel&rsquo;s services. If you want to be represented by your own lawyer, you may hire one at
        your own expense.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      How Will The Lawyers Be Paid?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        To date, Plaintiffs&rsquo; Counsel have not been paid any attorneys&rsquo; fees or reimbursed for any out-of-pocket Litigation Expenses. Any attorneys&rsquo; fees
        and Litigation Expenses will be awarded only as approved by the Court, in amounts determined to be fair and reasonable. The Settlement provides that Class Counsel
        may apply to the Court for an Attorneys&rsquo; Fees and Expenses Award from the Settlement Fund. Prior to the Final Approval Hearing, Class Counsel will move for
        an attorneys&rsquo; fee award not to exceed one-third of the Settlement Fund and $125,000 in Litigation Expenses. Plaintiffs may also seek service awards separate
        from the Claim Payment not to exceed $2,000 for each named Plaintiff, for a total of twelve thousand U.S. Dollars ($12,000).
      </p>
      <p>
        This is only a summary of the request for attorneys&rsquo; fees, Litigation Expenses, and service awards. Any motions in support of the requests will be available
        for viewing on the Settlement Website after they are filed by <b>November 24, 2026</b>. If you wish to review the motion papers, you may do so by viewing them at
        the Settlement Website, <a href="https://www.goodrxprivacysettlement.com/" target="_blank" style="color:#006cDb">www.goodrxprivacysettlement.com</a>.
      </p>
      <p>
        The Court will consider the motion for attorneys&rsquo; fees, Litigation Expenses, and service awards at or after the Final Approval Hearing.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      When And Where Will The Court Decide Whether To Approve The Settlement?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        The Court will hold the Final Approval Hearing on <b>February 11, 2027</b>, at 11:00 a.m., at the United States District Court for the Northern District of
        California, 1301 Clay Street, Oakland, CA 94612. The Final Approval Hearing may be moved to a different date or time without notice to you. The Final Approval
        Hearing could also be conducted remotely. Although you do not need to attend, if you plan to do so, you should check the Settlement Website or the Court&rsquo;s
        Public Access to Court Electronic Records (PACER) system at
        <a href="https://ecf.cand.uscourts.gov" target="_blank" style="color:#006cDb">https://ecf.cand.uscourts.gov</a> to confirm that the date has not been changed before
        making travel plans.
      </p>
      <p>
        At the Final Approval Hearing, the Court will consider whether the Settlement is fair, reasonable, and adequate. The Court will also consider whether to approve
        the requests for attorneys&rsquo; fees and Litigation Expenses, and any service awards for Plaintiffs. If there are any objections, the Court will consider them at
        this time. We do not know how long the Final Approval Hearing will take or when the Court will make its decision. The Court&rsquo;s decision may be appealed.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      Do I Have To Come To The Final Approval Hearing?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        No. Class Counsel will answer any questions the Court may have. You are, however, welcome to come at your own expense. If you send an objection, you do not have
        to come to Court to talk about it. As long as you file and serve your written objection on time, the Court will consider it. You may also hire your own lawyer to
        attend, but you are not required to do so.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      May I Speak At The Final Approval Hearing?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        You may ask the Court for permission to speak at the Final Approval Hearing. If you want to appear at the Final Approval Hearing, you may enter an appearance in
        the Litigation at your own expense, individually, or through counsel of your own choice, by filing with the Court a notice of appearance and your objection no
        later than <b>December 29, 2026</b>, or as the Court may otherwise direct. All documents sent to the Court by any Settlement Class Member, including any letter or
        document expressing the Settlement Class Member&rsquo;s desire to be excluded from the Class and any objection to the proposed Settlement, voluntary dismissal, or
        compromise, are filed electronically by the clerk and therefore will be available for public review. Any Settlement Class Member who does not enter an appearance
        will be represented by Class Counsel. You cannot request to speak at the Final Approval Hearing by telephone or email, but may file a request no later than seven
        (7) days before the Final Approval Hearing for permission to participate via Zoom.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.4em; font-weight:bold">
      How Do I Get More Information?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <p>
        The Court has appointed AB Data as the Settlement Administrator. Among other things, the Settlement Administrator is responsible for providing this Notice of the
        Settlement and processing Claim Forms.
      </p>
      <p>
        This <a href="../../../assets/docs/GoodRx Criteo - Long Form Notice V2.pdf" target="_blank" style="color:#006cDb">Notice</a> summarizes the Settlement Agreement.
        For the precise terms of the Settlement, please see the Settlement Agreement, which is available for your review
        at the Settlement Website, <a href="https://www.goodrxprivacysettlement.com/" target="_blank" style="color:#006cDb">www.goodrxprivacysettlement.com</a>, by accessing
        the Court docket in this case, for a fee, through the Court&rsquo;s PACER system at
        <a href="https://ecf.cand.uscourts.gov" target="_blank" style="color:#006cDb">https://ecf.cand.uscourts.gov</a>, or by visiting the office of the Clerk of the Court
        for the United States District Court for the Northern District of California, at either (1) the Ronald V. Dellums Federal Building &amp; United States Courthouse,
        1301 Clay Street, Suite 400 S Oakland, CA 94612; (2) the Phillip Burton Federal Building &amp; United States Courthouse, 450 Golden Gate Avenue, 16th Floor, San
        Francisco, CA 94102; or (3) the Robert F. Peckham Federal Building &amp; United States Courthouse, 280 South 1st Street, 2nd Floor, San Jose, CA 95113, between
        9:00 a.m. and 4:00 p.m., Monday through Friday, excluding Court holidays. The Settlement Website also has answers to common questions about the Settlement, Claim
        Form, and other information to help you determine whether you are a Settlement Class Member and whether you are eligible for a payment.
      </p>
      <p>
        You may contact the Settlement Administrator at:
      </p>
      <p style="text-align:center">
        GoodRx Data Disclosure Settlement<br>
        c/o A.B. Data, Ltd.<br>
        P.O. Box 173138<br>
        Milwaukee, WI 53217<br>
        Tel: <a href="tel:+18778889232" style="color:#006cDb">1-877-888-9232</a><br>
        Email: <a href="mailto:info@goodrxprivacysettlement.com" style="color:#006cDb">info@goodrxprivacysettlement.com</a>
      </p>
      <p>
        If your contact information changes, please enter your current information online at the Settlement Website, or send it to the Settlement Administrator at the
        address set forth above in the event the Settlement Administrator needs to contact you.
      </p>
    </div>
  </div>
</div>

<div class="container" id="mobile">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.0em; font-weight:bold">
      FAQs
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      What Is A Class Action Lawsuit?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        A class action is a lawsuit in which one or more representative plaintiffs (in this case, Plaintiffs) bring a lawsuit on behalf of themselves and other similarly
        situated persons (<i>i.e.</i>, a class) who have similar claims against the defendants. The representative plaintiffs, the court, and counsel appointed to represent
        the class all have a responsibility to make sure that the interests of all class members are adequately represented.
      </p>
      <p>
        Importantly, class members are NOT individually responsible for payment of attorneys&rsquo; fees or litigation expenses. In a class action, attorneys&rsquo; fees and
        litigation expenses are paid directly by the defendants, from the court-awarded judgment amount, or, as in this case, from the settlement fund, and such payment must
        be approved by the court. If there is no recovery on behalf of the class, the attorneys do not get paid.
      </p>
      <p>
        When a representative plaintiff enters into a settlement with a defendant on behalf of a class, such as in this Settlement with GoodRx and Criteo, the court will
        require that the members of the class be given notice of the settlement and an opportunity to be heard with respect to the settlement. The court then conducts a
        hearing (called a Final Approval Hearing) to determine, among other things, if the settlement is fair, reasonable, and adequate.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      Why Was There A Notice?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        Potential Settlement Class Members have a right to know about the proposed Settlement with GoodRx and Criteo before the Court decides whether to approve the
        Settlement.
      </p>
      <p>
        This <a href="../../../assets/docs/GoodRx Criteo - Long Form Notice V2.pdf" target="_blank" style="color:#006cDb">Notice</a> explains the cases in
        the consolidated litigation,<sup>1</sup> <i>Doe v. GoodRx Holdings, Inc. et al</i>, No. 3:23-cv-00501-AMO, pending in the U.S.
        District Court for the Northern District of California (the &ldquo;Litigation&rdquo;), the Settlement, your legal rights, what benefits are available, who is
        eligible for them, and how you can apply to receive your portion of the benefits if you are eligible. The purpose of this Notice is also to inform you of the Final
        Approval Hearing to be held by the Court to consider the fairness, reasonableness, and adequacy of the
        <a href="../../../assets/docs/Settlement Agreement.pdf" target="_blank" style="color:#006cDb">Settlement</a>, and to consider requests for awards of
        attorneys&rsquo; fees and litigation expenses, and any service awards for Plaintiffs.
      </p>
      <p style="font-size:.8em">
        <sup>1</sup> This Action was consolidated with <i>Doe v. GoodRx Holdings, Inc. et al</i>, No. 3:23-cv-00744-VC (N.D. Cal.), <i>Marquez v. GoodRx Holdings, Inc. et
        al</i>, No. 3:23-cv-00940-VC (N.D. Cal.), <i>Wilson v. GoodRx Holdings, Inc. et al</i>, No. 3:23-cv-01293-VC (N.D. Cal.), and <i>E.C. v. GoodRx Holdings, Inc. et
        al</i>, No. 3:23-cv-01508-VC (N.D. Cal.) on May 3, 2023. See ECF No. 85.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      What Are The Definitions Used In This Notice?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        This Notice incorporates by reference the definitions in the Amended Class Action Settlement Agreement and Release with GoodRx and Criteo (the &ldquo;Settlement
        Agreement&rdquo;).
      </p>
      <p>
        The Settlement Agreement and the Court&rsquo;s Preliminary Approval Order are posted on the Settlement Website. All capitalized terms used in this Notice, but not
        otherwise defined, shall have the same meanings as in the Settlement Agreement and the Court&rsquo;s Preliminary Approval Order.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      What Is This Litigation About?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        GoodRx is a combination telehealth and prescription coupon company that provides millions of people with telehealth services, coupons for prescription medication,
        and other health-related services each month. When people use GoodRx&rsquo;s services, GoodRx collects their personal and health information, including information
        about their prescription medications and health conditions, email addresses, and phone numbers. Plaintiffs allege that between at least 2017 and 2020, GoodRx
        disclosed this sensitive personal health information to advertising and analytics companies, including Criteo and Remaining Defendants, through GoodRx&rsquo;s
        incorporation of Criteo and Remaining Defendants&rsquo; technologies on the GoodRx platform. Plaintiffs also allege that Criteo and Remaining Defendants used this
        information for their own purposes.
      </p>
      <p>
        Plaintiffs brought this Litigation against GoodRx, Criteo, and Remaining Defendants on behalf of themselves and the Class alleging that this conduct violated Class
        Members&rsquo; privacy rights along with various state privacy and consumer protections laws. Plaintiffs assert claims against GoodRx, Criteo, and Remaining
        Defendants for intrusion upon seclusion, unjust enrichment, violation of the California Confidentiality of Medical Information Act (&ldquo;CMIA&rdquo;), violation
        of the California Invasion of Privacy Act (&ldquo;CIPA&rdquo;), violation of the California Consumers Legal Remedies Act (&ldquo;CLRA&rdquo;), violation of
        California&rsquo;s Unfair Competition Law (&ldquo;UCL&rdquo;), violation of New York&rsquo;s General Business Law (&ldquo;GBL&rdquo;), violation of the Illinois
        Consumer Fraud and Deceptive Business Practices Act, negligence, and negligence per se and seek compensation for GoodRx users whose information was disclosed to
        Criteo and Remaining Defendants without their consent.
      </p>
      <p>
        GoodRx and Criteo dispute Plaintiffs&rsquo; allegations and deny that they violated any law. GoodRx and Criteo further maintain that they have valid and meritorious
        defenses as to some or all of the claims asserted in this Litigation. Nevertheless, to avoid the expense and uncertainty of further litigation, GoodRx and Criteo
        have agreed to settle the claims asserted against them in this Litigation, and to pay a total of thirty-two million U.S. Dollars ($32,000,000) for the benefit of
        the Settlement Class to resolve the Settlement Class&rsquo;s claims against them. This Settlement does not include the claims Plaintiffs maintain against the
        Remaining Defendants, which they continue to pursue. If the Settlement is approved, each Authorized Claimant will receive a share of the Settlement Amount plus any
        interest that may accrue, less any Court-approved disbursements, including: (i) reasonable Notice and Settlement Administration Costs; (ii) any taxes owed by the
        Settlement Fund; (iii) any Settlement Fund account costs to hold and invest the Settlement fund; (iv) any Attorneys&rsquo; Fees and Expenses Award; (v) service
        awards to Class Representatives; and (vi) any other costs or awards approved by the Court (the &ldquo;Net Settlement Fund&rdquo;). The share of the Net Settlement
        Fund received by each Authorized Claimant (the &ldquo;Claim Payment&rdquo;) will depend on the total number of eligible claims that receive approval to
        participate in the Settlement. If the Settlement is not approved, the Litigation will continue against GoodRx and Criteo, and Plaintiffs will continue to pursue
        their claims against GoodRx and Criteo along with their claims against Remaining Defendants.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      What Is The History Of This Litigation?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        On February 1, 2023, the Federal Trade Commission (&ldquo;FTC&rdquo;) filed an action against GoodRx alleging it violated the FTC Act and the FTC&rsquo;s Health
        Breach Notification Rule by disclosing its users&rsquo; personally identifiable information and details about their medications and sensitive health conditions to
        third parties, including Criteo and Remaining Defendants.
      </p>
      <p>
        Beginning on February 2, 2023, putative class action complaints were filed against GoodRx as a result of the alleged disclosure of personal and health information
        of its users. Those actions were consolidated with this Litigation on May 3, 2023 and a Consolidated Class Action Complaint was filed on May 26, 2023. On July 7,
        2023, Lowey Dannenberg, P.C., and Bursor &amp; Fisher, P.A. were appointed interim co-lead class counsel (&ldquo;Class Counsel&rdquo;) and given the authority to
        conduct settlement discussions in this Litigation, and any subsequently related actions, on behalf of Plaintiffs and proposed Class Members. GoodRx moved to compel
        arbitration and dismiss the Litigation. Plaintiffs opposed GoodRx&rsquo;s motions. Ultimately, these motions were dismissed without prejudice pending the outcome of
        a forthcoming mediation.
      </p>
      <p>
        On January 10, 2024, Plaintiffs and GoodRx engaged in the first mediation conference before the Honorable Ellen Sickles James. Plaintiffs and GoodRx then engaged in
        a second mediation on March 7, 2024 before the Honorable Wayne Andersen (ret.) that lasted a full day. Plaintiffs and GoodRx made significant progress and following
        multiple telephonic conferences, reached a settlement.
      </p>
      <p>
        In 2025, Plaintiffs and Criteo reengaged in settlement negotiations. Plaintiffs and Criteo also reached an agreement in their negotiations. Then settlement terms
        with GoodRx and Criteo were further refined and combined. On November 19, 2025, Plaintiffs, GoodRx, and Criteo reached an amended settlement, reflected in the
        Settlement Agreement.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      Why Is There A Settlement?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        Plaintiffs and Class Counsel believe that Settlement Class Members have been damaged by GoodRx and Criteo&rsquo;s conduct. GoodRx and Criteo do not admit the
        allegations made by Plaintiffs, believe that they have meritorious defenses to Plaintiffs&rsquo; allegations, and believe that Plaintiffs&rsquo; claims would have
        been rejected prior to trial, at trial (had Plaintiffs successfully certified a class and survived summary judgment motions), or on appeal. As a result, GoodRx and
        Criteo believe Plaintiffs would have received nothing if the Litigation had continued to trial.
      </p>
      <p>
        The Court has not decided in favor of either Plaintiffs or GoodRx and Criteo. Instead, Class Counsel engaged in negotiations with GoodRx and Criteo to reach a
        negotiated resolution of the Litigation. The
        <a href="../../../assets/docs/Settlement Agreement.pdf" target="_blank" style="color:#006cDb">Settlement</a> allows both sides to avoid the risks and costs of
        lengthy litigation and the uncertainty of pre-trial
        proceedings, a trial, and appeals, and, if approved, will permit Settlement Class Members who file timely and valid Claim Forms to receive some compensation,
        rather than risk ultimately receiving nothing. Plaintiffs and Class Counsel believe the Settlement is in the best interest of all Settlement Class Members.
      </p>
      <p>
        GoodRx and Criteo have agreed to pay a total of thirty-two million U.S. Dollars ($32,000,000) in cash for the benefit of the proposed Settlement Class. If the
        Settlement is approved, each Settlement Class Member who submits a timely and valid Settlement Claim Form may be eligible to receive a Claim Payment from the Net
        Settlement Fund.
      </p>
      <p>
        If the Settlement is approved, the Litigation and related class actions will be resolved against GoodRx and Criteo, and all Released Claims against the Released
        Parties will be released by the Releasing Parties. If the Settlement is not approved, GoodRx and Criteo will remain as defendants in the Litigation, and Plaintiffs
        will continue to pursue their claims against GoodRx, Criteo, and Remaining Defendants.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      How Do I Know If I Am A Settlement Class Member?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        In the
        <a href="../../../assets/docs/0379. (09-08-2026) ORDER PRELIMINARILY APPROVING THE PROPOSED CLASS ACTION SETTLEMENT, SCHEDULING HEARING FOR FINAL APP.pdf"
           target="_blank" style="color:#006cDb">Preliminary Approval Order</a>, the Court preliminarily approved the following Settlement Class:
      </p>
      <p>
        <i>All natural persons in the United States who used any website, app, or service made available by or through GoodRx at any time prior to April 20, 2024.</i>
      </p>
      <p>
        The Preliminary Approval Order was issued by the Court on <b>September 8, 2026</b>. Not everyone who fits the description will be a Settlement Class Member. Please
        see the question below, &ldquo;Are There Exceptions To Being Included In The Settlement Class?,&rdquo; for a discussion of exclusions from the Settlement Class.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      Are There Exceptions To Being Included In The Settlement Class?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        Yes. Excluded from the Settlement Class are: (a) Defendants and their affiliates, parents, subsidiaries, officers, and directors; (b) the Opt-Outs; (c) Meta and
        Google; as well as (d) the judges presiding over this matter and the clerks of said judges. Anyone who excludes themselves is also not included in the Settlement
        Class (see the question below, &ldquo;How Do I Exclude Myself?&rdquo;).
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      What If I Am Still Not Sure If I Am Included In The Settlement Class?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        If you are still not sure whether you are included in the Settlement Class, you can ask for free help. You can email
        <a href="mailto:info@goodrxprivacysettlement.com" style="color:#006cDb">info@goodrxprivacysettlement.com</a>, call toll-free
        <a href="tel:+18778889232" style="color:#006cDb">1-877-888-9232</a>, or visit the
        Settlement Website, <a href="https://www.goodrxprivacysettlement.com/" target="_blank" style="color:#006cDb">www.goodrxprivacysettlement.com</a>, for more information.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      What Does The Settlement Provide?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        GoodRx and Criteo have agreed to pay a sum of thirty-two million U.S. Dollars ($32,000,000) for the benefit of the proposed Settlement Class. If the Settlement is
        approved, each Settlement Class Member who submits a timely and valid Claim Form will receive an equal share of the Net Settlement Fund after any Court-approved
        disbursements, including (i) Notice and Settlement Administration Costs; (ii) Taxes; (iii) Settlement Fund account costs; and (iv) attorneys&rsquo; fees and expenses,
        (v) service awards, and (vi) any other costs or awards approved by the Court, are paid.
      </p>
      <p>
        The Settlement gives GoodRx and Criteo the right, but not the obligation, in their sole discretion to terminate the Settlement in the event that the number of
        Settlement Class Members who timely exercise their right to request exclusion from the Settlement Class exceeds an agreed upon number.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      How Will I Get A Payment?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        If you are a Settlement Class Member and do not exclude yourself, you are eligible to submit a
        <a href="https://goodrxprivacysettlement.com/file-not-noticed" target="_blank" style="color:#006cDb">Claim Form</a> to receive your share of money from the Net
        Settlement Fund. Claim Forms must be submitted online at the Settlement Website on or before 11:59 p.m. Eastern Time on <b>December 29, 2026</b> OR mailed to the below
        address postmarked no later than <b>December 29, 2026</b>:
      </p>
      <p style="text-align:center">
        GoodRx Data Disclosure Settlement<br>
        c/o A.B. Data, Ltd.<br>
        P.O. Box 173138<br>
        Milwaukee, WI 53217
      </p>
      <p>
        Following the timely submission and receipt of your Claim Form online, a printable &ldquo;Confirmation of Claim Receipt&rdquo; will be displayed on the screen,
        which will acknowledge receipt of your Claim. If you do not submit a Claim Form, you will not receive any payment under the Settlement.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      How Much Will My Payment Be?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        At this time, it is not known precisely how much each Authorized Claimant will receive as the Settlement Payment or when payments will be made. The amount of the
        Settlement Payment will depend on the number of claims that receive approval.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      When Will I Receive A Payment?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        The Court will hold the Final Approval Hearing on <b>February 11, 2027</b> to decide whether to approve the Settlement. If the Court approves the Settlement, there
        may be appeals after that. It can sometimes take a year or more for the appellate process to conclude.
      </p>
      <p>
        Do not contact the Court or Court clerk for updates.
      </p>
      <p>
        Please be patient; status updates will be posted on the Settlement Website.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      What Do I Have To Do After I File A Claim Form?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        After you file a <a href="https://goodrxprivacysettlement.com/file-not-noticed" target="_blank" style="color:#006cDb">Claim Form</a>, the Settlement Administrator
        will evaluate your Claim Form to determine if you have provided sufficient information to validate your
        membership in the Settlement Class and to approve the claim submitted. If the Settlement Administrator determines that your Claim Form is deficient or defective,
        it will contact you, and you will have twenty (20) days from the date of the written notice to cure the deficiencies. If you subsequently provide information that
        satisfies the Settlement Administrator concerning the validity of your Claim Form, you will not have to do anything else. If the defect is not cured within the
        20-day period, then the Claim will be deemed invalid. If any disputes cannot be resolved, Class Counsel will submit them to the Court, and the Court will make a
        final determination of the validity of your Claim Form.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      What Am I Giving Up To Receive A Payment?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        Unless you exclude yourself, you remain a Settlement Class Member. That means you cannot sue, continue to sue, or be part of any other lawsuit about the Released
        Claims in this Litigation or any other action against GoodRx and Criteo. Upon the Effective Date of the Settlement, Plaintiffs and the Releasing Parties shall
        release and be deemed to release and forever discharge and shall be forever enjoined from prosecuting the Released Claims against the Released Parties.
      </p>
      <p>
        The capitalized terms used in this paragraph are defined in the Settlement Agreement, Preliminary Approval Order, or this Notice. For easy reference, certain of
        these terms are copied below:
      </p>
      <p>
        &ldquo;Releasing Parties&rdquo; means Plaintiffs and the Settlement Class Members who do not timely and validly opt out from the Settlement pursuant to Fed. R.
        Civ. P. 23(c) and in accordance with the procedure to be established by the Court, and each of their past, present, and future heirs, estates, trustees,
        principals, beneficiaries, guardians, executors, administrators, representatives, agents, attorneys, partners, successors, predecessors in-interest, and assigns
        and/or anyone claiming through them or acting or purporting to act for them or on their behalf.
      </p>
      <p>
        &ldquo;Released Parties&rdquo; means jointly and severally, individually and collectively, Defendants GoodRx and Criteo, their predecessors; successors; assigns;
        insurers; and any and all past, present, and future parents, owners, subsidiaries, divisions, departments, and affiliates, and all of their past, present, and
        future heirs, executors, devisees, administrators, officers, executives, directors, stockholders, partners, members, agents, attorneys, advisors, auditors,
        accountants, contractors, servants, employees, representatives, insurers, and assignees.
      </p>
      <p>
        &ldquo;Released Claims&rdquo; means any and all manner of claims, counterclaims, lawsuits, set-offs, costs, expenses, attorneys&rsquo; fees and costs, losses,
        rights, demands, charges, complaints, actions, suits, causes of action, obligations, debts, contracts, penalties, damages, or liabilities of any nature whatsoever,
        known, unknown, or capable of being known, in law or equity, fixed or contingent, accrued or unaccrued, and matured or not matured that arise out of, or are based
        upon or connected to, or relate in any way to the Data Disclosure or GoodRx and Criteo&rsquo; use of Pixels, SDKs, cookies, APIs, or any similar technologies, or
        that were or could have been asserted in the litigation. Released Claims include the release of unknown claims. Released Claims do not include the right of any of
        the Releasing Parties or any of the Released Parties to enforce the terms of the Settlement contained in the Settlement Agreement.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      What If I Do Nothing?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        You are automatically a member of a Settlement Class if you fit the Settlement Class description. However, if you do not submit a timely and valid Claim Form, you
        will not receive any payment from the Settlement. You will be bound by past and any future Court rulings, including rulings on the Settlement and release. Unless
        you exclude yourself, you will not be able to start a lawsuit, continue with a lawsuit, or be a part of any other lawsuit against GoodRx or Criteo on the basis of
        the Released Claims. Please see the question above, &ldquo;What Am I Giving Up To Receive A Payment?,&rdquo; for a description of the Released Claims.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      What If I Do Not Want To Be In The Settlement Class?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        If you are a Settlement Class Member, do not want to remain in the Settlement Class, and do not want a payment from the Settlement, then you must take steps to
        exclude yourself from the Settlement. This is also sometimes referred to as &ldquo;opting out&rdquo; of a class. See the question below, &ldquo;How Do I Exclude
        Myself?&rdquo;
      </p>
      <p>
        If you validly exclude yourself from the Settlement Class of which you would otherwise be a member, you may file a lawsuit against GoodRx or Criteo on your own for
        the claims being resolved by the Settlement. However, you will not receive any money from the Settlement, and Class Counsel will no longer represent you with
        respect to any claims against GoodRx and Criteo.
      </p>
      <p>
        If you want to receive money from the Settlement, do not exclude yourself. You must file a Claim Form to receive any payment from the Settlement.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      How Do I Exclude Myself?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        You can exclude yourself by sending a written &ldquo;Request for Exclusion.&rdquo; You cannot exclude yourself by telephone. Your written Request for Exclusion must be
        sent to the Settlement Administrator postmarked no later than <b>December 29, 2026</b> and sent by U.S. Mail or other delivery service to:
      </p>
      <p style="text-align:center">
        GoodRx Data Disclosure Settlement<br>
        Attn: Exclusions<br>
        P.O. Box 173001<br>
        Milwaukee, WI 53217
      </p>
      <p>
        The written Request for Exclusion must (i) identify the case name and number of the Litigation (<i>Doe v. GoodRx Holdings, Inc., et al.</i>, Case No 4:23-cv-00501-AMO
        (N.D. Cal.)); (ii) identify your full name, current address, telephone number, and email address; (iii) include the claimant ID code and other information included
        on the Summary Notice of Proposed Class Action Settlement (&ldquo;Short Form Notice&rdquo;) provided by the Settlement Administrator that identifies you as a
        Settlement Class Member; (iv) include your original signature, and, if represented by counsel, be signed by your counsel; and (v) include a statement clearly
        indicating your intent to be excluded from the Settlement.
      </p>
      <p>
        A Request for Exclusion that does not include all of the foregoing information, that does not contain the proper signature, that is sent to an address other than
        the one designated above, or that is not sent within the time specified shall be invalid and the person(s) filing such an invalid request shall be a Settlement
        Class Member and shall be bound by the Settlement, if approved.
      </p>
      <p>
        All persons who submit valid and timely Requests for Exclusion in the manner set forth above shall have no rights under the Settlement, shall not share in the
        distribution of the Net Settlement Fund, and shall not be bound by the Settlement. In addition, such persons will not be entitled to object to the Settlement or
        appear at the Final Approval Hearing.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      If I Do Not Exclude Myself, Can I Sue GoodRx Or Criteo For The Same Thing Later?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        No. Unless you exclude yourself from this Settlement, you give up any right to sue GoodRx and Criteo for the Released Claims that the Settlement resolves.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      If I Exclude Myself, Can I Get Money From The Settlement?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        No. You will not get any money from the Settlement if you exclude yourself.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      If I Exclude Myself, Can I Still Object?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        No. If you exclude yourself, you are no longer a Settlement Class Member and may not object to any aspect of the Settlement.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      How Do I Tell The Court What I Think About The Settlement?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        If you are a Settlement Class Member and you do not exclude yourself, you can tell the Court what you think about the Settlement. You can object to all or any part
        of the Settlement, the application for attorneys&rsquo; fees and expenses, and/or service awards for Plaintiffs. You can give reasons why you think the Court should
        approve them or not. You cannot ask the Court to order a different settlement; the Court can only approve or reject the Settlement. If the Court denies approval, no
        settlement payments will be sent out, and the lawsuit will continue. If that is what you want to happen, you should object. The Court will consider your views. If
        you want to make an objection, you may enter an appearance in the Litigation, at your own expense, individually or through counsel of your own choice, by
        electronically filing or mailing a notice of appearance and your objection to the Clerk of Court, United States District Court for the Northern District of
        California, 1301 Clay Street, Suite 400 S Oakland, CA 94612 by <b>December 29, 2026</b>.
      </p>
      <p>
        Any Settlement Class Member who does not enter an appearance will be represented by Class Counsel. If you choose to object, you must file a written objection. You
        cannot make an objection by telephone or email. Your written objection must include: (i) the case name and number of the Litigation (<i>Doe v. GoodRx Holdings,
        Inc., et al.</i>, Case No 4:23-cv-00501-AMO (N.D. Cal.)); (ii) your full name, current address, telephone number, and email address; (iii) your original signature;
        (iv) proof or an attestation that you are a member of the Settlement Class, which proof may include the claimant ID code and other information included on the
        Short Form Notice provided by the Settlement Administrator that identifies you as a Settlement Class Member; (v) a statement of whether the objection applies only
        to you, to a specific subset of the Settlement Class, or to the entire Settlement Class; (vi) a statement of the legal and factual basis for the objection; (vii)
        copies of any documents that you wish to submit in support of your position; (viii) identification of all counsel representing you, if any; (ix) the signature of
        your duly authorized attorney or other duly authorized representative, if any. Note that all documents sent to the Court by any Settlement Class member, including
        any letter or document expressing the Settlement Class Member&rsquo;s desire to be excluded from the Class and any objection to the proposed Settlement, voluntary
        dismissal, or compromise, are filed electronically by the clerk and therefore will be available for public review. Objections should thus not include medical
        documentation or sensitive private information.
      </p>
      <p>
        If you file a timely written objection, you may, but are not required to, appear at the Final Approval Hearing. If you intend to speak at the Final Approval
        Hearing (whether <i>pro se</i> or through an attorney), you must file a notice of appearance and your written objection must identify: (a) the attorney(s)
        representing you who will appear at the Final Approval Hearing by including counsel&rsquo;s name, address, phone number, and email address; (b) any witnesses
        (including yourself, if applicable) that you or they may seek to call to testify at the Final Approval Hearing; and (c) all exhibits you may introduce into
        evidence at the Final Approval Hearing.
      </p>
      <p>
        If you do not timely and validly submit your objection, your views will not be considered by the Court or any court on appeal. Check the Settlement Website,
        <a href="https://www.goodrxprivacysettlement.com/" target="_blank" style="color:#006cDb">www.goodrxprivacysettlement.com</a>, for updates on important dates and
        deadlines relating to the Settlement.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      What Is The Difference Between Objecting And Excluding Myself?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        Objecting is telling the Court that you do not like something about the Settlement. You can object to the Settlement only if you remain a Settlement Class Member
        and do not exclude yourself from the Settlement. Excluding yourself from the Settlement is telling the Court that you do not want to be a part of the Settlement
        Class. If you exclude yourself, you have no right to object to the Settlement because it no longer affects you.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      Do I Have A Lawyer In This Case?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        The Court has appointed the lawyers listed below to represent you and the Settlement Class in this Litigation:
      </p>
      <div class="table-responsive">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td style="font-weight:bold; vertical-align:middle; width:25%">
                <img class="brand__logo" src="../../../assets/images/LogoLowey.png" alt="">
              </td>
              <td style="vertical-align: middle; width: 75%; font-size: .8em">
                <b>Christian Levis</b><br />
                LOWEY DANNENBERG, P.C.<br />
                44 South Broadway<br />
                Suite 1100<br />
                White Plains, NY 10601<br />
              </td>
            </tr>
            <tr>
              <td style="font-weight:bold; vertical-align:middle; width:25%">
                <img class="brand__logo" src="../../../assets/images/BFishlogo.png" alt="">
              </td>
              <td style="vertical-align: middle; width: 75%; font-size: .8em">
                <b>L. Timothy Fisher</b><br />
                BURSOR &amp; FISHER, P.A.<br />
                1990 North California Blvd., 9th Floor<br />
                Walnut Creek, CA 94596<br />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        These lawyers are called Class Counsel. Class Counsel may apply to the Court for payment of attorneys&rsquo; fees and Litigation Expenses that will be paid from
        the Settlement Fund. You will not otherwise be charged for Class Counsel&rsquo;s services. If you want to be represented by your own lawyer, you may hire one at
        your own expense.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      How Will The Lawyers Be Paid?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        To date, Plaintiffs&rsquo; Counsel have not been paid any attorneys&rsquo; fees or reimbursed for any out-of-pocket Litigation Expenses. Any attorneys&rsquo; fees
        and Litigation Expenses will be awarded only as approved by the Court, in amounts determined to be fair and reasonable. The Settlement provides that Class Counsel
        may apply to the Court for an Attorneys&rsquo; Fees and Expenses Award from the Settlement Fund. Prior to the Final Approval Hearing, Class Counsel will move for
        an attorneys&rsquo; fee award not to exceed one-third of the Settlement Fund and $125,000 in Litigation Expenses. Plaintiffs may also seek service awards separate
        from the Claim Payment not to exceed $2,000 for each named Plaintiff, for a total of twelve thousand U.S. Dollars ($12,000).
      </p>
      <p>
        This is only a summary of the request for attorneys&rsquo; fees, Litigation Expenses, and service awards. Any motions in support of the requests will be available
        for viewing on the Settlement Website after they are filed by <b>November 24, 2026</b>. If you wish to review the motion papers, you may do so by viewing them at
        the Settlement Website, <a href="https://www.goodrxprivacysettlement.com/" target="_blank" style="color:#006cDb">www.goodrxprivacysettlement.com</a>.
      </p>
      <p>
        The Court will consider the motion for attorneys&rsquo; fees, Litigation Expenses, and service awards at or after the Final Approval Hearing.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      When And Where Will The Court Decide Whether To Approve The Settlement?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        The Court will hold the Final Approval Hearing on <b>February 11, 2027</b>, at 11:00 a.m., at the United States District Court for the Northern District of
        California, 1301 Clay Street, Oakland, CA 94612. The Final Approval Hearing may be moved to a different date or time without notice to you. The Final Approval
        Hearing could also be conducted remotely. Although you do not need to attend, if you plan to do so, you should check the Settlement Website or the Court&rsquo;s
        Public Access to Court Electronic Records (PACER) system at
        <a href="https://ecf.cand.uscourts.gov" target="_blank" style="color:#006cDb">https://ecf.cand.uscourts.gov</a> to confirm that the date has not been changed before
        making travel plans.
      </p>
      <p>
        At the Final Approval Hearing, the Court will consider whether the Settlement is fair, reasonable, and adequate. The Court will also consider whether to approve
        the requests for attorneys&rsquo; fees and Litigation Expenses, and any service awards for Plaintiffs. If there are any objections, the Court will consider them at
        this time. We do not know how long the Final Approval Hearing will take or when the Court will make its decision. The Court&rsquo;s decision may be appealed.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      Do I Have To Come To The Final Approval Hearing?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        No. Class Counsel will answer any questions the Court may have. You are, however, welcome to come at your own expense. If you send an objection, you do not have
        to come to Court to talk about it. As long as you file and serve your written objection on time, the Court will consider it. You may also hire your own lawyer to
        attend, but you are not required to do so.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      May I Speak At The Final Approval Hearing?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        You may ask the Court for permission to speak at the Final Approval Hearing. If you want to appear at the Final Approval Hearing, you may enter an appearance in
        the Litigation at your own expense, individually, or through counsel of your own choice, by filing with the Court a notice of appearance and your objection no
        later than <b>December 29, 2026</b>, or as the Court may otherwise direct. All documents sent to the Court by any Settlement Class Member, including any letter or
        document expressing the Settlement Class Member&rsquo;s desire to be excluded from the Class and any objection to the proposed Settlement, voluntary dismissal, or
        compromise, are filed electronically by the clerk and therefore will be available for public review. Any Settlement Class Member who does not enter an appearance
        will be represented by Class Counsel. You cannot request to speak at the Final Approval Hearing by telephone or email, but may file a request no later than seven
        (7) days before the Final Approval Hearing for permission to participate via Zoom.
      </p>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.2em; font-weight:bold">
      How Do I Get More Information?
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:.9em">
      <p>
        The Court has appointed AB Data as the Settlement Administrator. Among other things, the Settlement Administrator is responsible for providing this Notice of the
        Settlement and processing Claim Forms.
      </p>
      <p>
        This <a href="../../../assets/docs/GoodRx Criteo - Long Form Notice V2.pdf" target="_blank" style="color:#006cDb">Notice</a> summarizes the Settlement Agreement.
        For the precise terms of the Settlement, please see the Settlement Agreement, which is available for your review
        at the Settlement Website, <a href="https://www.goodrxprivacysettlement.com/" target="_blank" style="color:#006cDb">www.goodrxprivacysettlement.com</a>, by accessing
        the Court docket in this case, for a fee, through the Court&rsquo;s PACER system at
        <a href="https://ecf.cand.uscourts.gov" target="_blank" style="color:#006cDb">https://ecf.cand.uscourts.gov</a>, or by visiting the office of the Clerk of the Court
        for the United States District Court for the Northern District of California, at either (1) the Ronald V. Dellums Federal Building &amp; United States Courthouse,
        1301 Clay Street, Suite 400 S Oakland, CA 94612; (2) the Phillip Burton Federal Building &amp; United States Courthouse, 450 Golden Gate Avenue, 16th Floor, San
        Francisco, CA 94102; or (3) the Robert F. Peckham Federal Building &amp; United States Courthouse, 280 South 1st Street, 2nd Floor, San Jose, CA 95113, between
        9:00 a.m. and 4:00 p.m., Monday through Friday, excluding Court holidays. The Settlement Website also has answers to common questions about the Settlement, Claim
        Form, and other information to help you determine whether you are a Settlement Class Member and whether you are eligible for a payment.
      </p>
      <p>
        You may contact the Settlement Administrator at:
      </p>
      <p style="text-align:center">
        GoodRx Data Disclosure Settlement<br>
        c/o A.B. Data, Ltd.<br>
        P.O. Box 173138<br>
        Milwaukee, WI 53217<br>
        Tel: <a href="tel:+18778889232" style="color:#006cDb">1-877-888-9232</a><br>
        Email: <a href="mailto:info@goodrxprivacysettlement.com" style="color:#006cDb">info@goodrxprivacysettlement.com</a>
      </p>
      <p>
        If your contact information changes, please enter your current information online at the Settlement Website, or send it to the Settlement Administrator at the
        address set forth above in the event the Settlement Administrator needs to contact you.
      </p>
    </div>
  </div>
</div>
